
<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
       <v-row class="mt-n3">
        <v-col cols="3">
            <v-autocomplete
              v-model="selectedUsers"
              :items="userstats.users_data"
              item-value="user_id"
              item-text="name"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              @change="changedFilter"
            >
          </v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-btn class="white--text" small :color="primary_color" @click="resetStats()"  x-large block>
            {{ 'Reset' | translate }}
          </v-btn>
        </v-col>

      </v-row>


      <v-row no-gutters>
        <v-col cols="12">

          <v-tabs
          v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="/coursesstats" > {{ 'Per Course' | translate}} </v-tab>
              <v-tab href="#viewcoursewisepassingpercentage"> {{ 'Per User' | translate }} </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs" background="#fafafa">
              <v-tab-item value="viewcoursestats">
              </v-tab-item>
          </v-tabs-items>

           <v-tabs-items v-model="tabs">
              <v-tab-item value="viewcoursewisepassingpercentage">
                <template>
                      <div v-for="(userStats , index) in filtereduserstats" :key="index" class="my-12" >
                        <v-card shaped outlined elevation="2" class="mt-4 pa-5">
                        <v-toolbar-title class="grey--text text--darken-4 text-center font-weight-bold">
                            {{userStats.name}}
                            </v-toolbar-title>
                            
                            <div class="d-flex flex-wrap"> 
                                <template>
                                <SimpleCard type="CoursesSubscribed" title="Courses Subscribed" description="Number of Courses Subscribed" color="blue" :totalcount="userStats.no_courses_sub"/>
                                <SimpleCard type="CoursesActive" title="Active Courses" description="Number of Active Courses" color="green" :totalcount="userStats.no_acitve_courses"/>
                                </template>
                            </div>
                    

                            <div class="row" >
                                    <div class="col" >
                                    <v-card 
                                        height="520"
                                    >
                                        <template>
                                        <v-carousel
                                            show-arrows-on-hover
                                        height="520"

                                        >
                                            <v-carousel-item
                                            v-for="(slide, i) in slides"
                                            :key="i"
                                            >
                                            <v-card-title> {{slide.name | translate}} </v-card-title>
                                            <v-sheet
                                                color="white"
                                                height="100%"
                                            >
                                                <v-row
                                                class="ma-1"
                                                align="center"
                                                justify="center"
                                                >
                                                 <template v-if="slide.type=='Bar'">
                                                    <BarChart :chart-data="convertBarChart('chartData',userStats.learn_progress)" :chart-options="convertBarChart('chartOptions',userStats.learn_progress)"
                                                    />
                                                </template>
                                                <template v-if="slide.type=='Doughnut'">
                                                    <DoughnutChart :chart-data="convertDoughnutChart('chartData',userStats.pass_percentage)" :chart-options="convertDoughnutChart('chartOptions',userStats.pass_percentage)"
                                                    />
                                                </template>
                                                
                                                </v-row>
                                            </v-sheet>
                                            </v-carousel-item>
                                        </v-carousel>
                                        </template>
                                    </v-card>
                                    </div>
                            
                            <div class="col-md-auto" v-if="userStats.courses.length">
                                <template>
                                <v-card
                                    class="mx-auto overflow-auto"
                                    max-width="400"
                                    height="520"
                                >
                                    <v-toolbar
                                    :color="primary_color"
                                    dark
                                    style="position: sticky;
                                    top: 0;
                                    z-index: 999;"
                                    >
                                    <v-toolbar-title>{{ "Courses" | translate}}</v-toolbar-title>
                                    </v-toolbar>
                                    
                                        <v-list two-line>
                                            <v-list-group
                                            v-for="(item, index) in userStats.courses"
                                            :key="index"
                                            v-model="item.active"
                                            :prepend-icon="item.action"
                                            no-action
                                            >
                                            <template v-slot:activator>
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item.course_name"></v-list-item-title>
                                                    <v-list-item-action-text
                                                        :class="item.active ? 'text-blue':'text--primary'"
                                                    > 
                                                    {{'Course Progress' | translate}} <b>{{item.course_progress}}% </b></v-list-item-action-text>
                                                    <v-progress-linear
                                                      :value="item.course_progress"
                                                      color="green"
                                                    ></v-progress-linear>
                                                    <v-list-item-action-text v-if="item.course_ends_on">{{'Ends' |translate}} : {{convertDate(item.course_ends_on)}}  </v-list-item-action-text>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-list-item-action-text>{{item.modules.length}} {{'Modules' |translate}} </v-list-item-action-text>
                                                    <v-icon :class="item.active ? 'text-blue':'text-grey'"> mdi-file </v-icon>
                                                </v-list-item-action>
                                            </template>

                                            <v-card elevation="5" class="pa-2 pb-6 mb-2"> 
                                                <template>
                                                    <div v-for="(moduleItem , moduleIndex) in item.modules" :key="moduleIndex">
                                                        <ModuleCard :width="100" color="grey" :value="moduleItem" />
                                                    </div>
                                                </template>
                                            </v-card>

                                            </v-list-group>
                                        </v-list>

                                </v-card>

                                </template>
                            </div>
                            
                            </div>
                        </v-card>

                      </div>
                </template>
              </v-tab-item>
           </v-tabs-items>

           <div class="text-center" ref="userData">
                <v-layout row justify-center v-if="isLoading">
                    <v-layout row justify-center align-center>
                        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                    </v-layout>
                </v-layout>
           </div>

        </v-col>
      </v-row>

    </v-container>

</v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_COMPANY_SETTINGS,
  FETCH_USER_STATS,
  RESET_STATE
} from "@/store/actions.type";

import { SET_LOADING } from "@/store/mutations.type";

export default {
  name: "Quiz",
  async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE),
    await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile');
    await store.dispatch(FETCH_USER_STATS, '');

    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "User Statistics",
      search: "",
      primary_color: '',
      tabs:"viewcoursewisepassingpercentage",
      storage_url: "",
      selectedUsers:[],
      filtereduserstats:[],
      lastPulledPage:1,
      querriedApi: false,
      isLoading: false,
        slides: [
            {
                'name' : 'Pass Percentage of currently Subscribed Courses',
                'type' : 'Doughnut',
            },
            {
                'name' : 'Status of learning progress',
                'type' : 'Bar',
            },
        ],
    };
  },
  components: {
    Header: () => import("@/components/header/Header"),
    BarChart: () => import("@/components/charts/Bar"),
    DoughnutChart: () => import("@/components/charts/Doughnut"),
    SimpleCard: () => import("@/components/cards/SimpleCard"),
    ModuleCard: () => import("@/components/cards/ModuleCard"),
  },
  computed: {
    ...mapGetters(['currentUser','loadingdata','companysettings','userstats']),
   
  },
  created() {
    this.storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
    this.filtereduserstats = this.userstats.users_data;
  },
  async mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color  = company_meta.primary_color
    if(company_meta.hasOwnProperty('has_quiz')){
      this.has_quiz = (company_meta.has_quiz==='true') //since returned value is a tring and not boolean
    }

    if(this.companysettings.hasOwnProperty('setting_data')){
        this.daily_quiz_question_count = this.companysettings.setting_data.daily_quiz_question_count
        this.daily_quiz_passing_percent = this.companysettings.setting_data.daily_quiz_passing_percent
    }

    this.$nextTick(function(){
        window.addEventListener('scroll', this.onScroll);
        // this.onScroll();
    })

  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    resetStats(){
      this.selectedUsers = [];
      this.filtereduserstats = this.userstats;
    },
    convertDoughnutChart(option, data){
      if(option == 'chartData'){
          let chartData = {
          labels: [this.$t('Passed'), this.$t('Not Passed')],
          datasets: [
            {
              backgroundColor: ['#41B883', '#E46651'],
              data: [data.passed_percent, data.not_passed_percent]
            }
          ]
        }
        return chartData;
      }else{
        let chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              legend: {
                  display: true,
                  position: 'bottom',
              }
          }
        }
        return chartOptions;
      }
    },
      convertBarChart(option, data){
      if(option=='chartData'){
        let datalabels = Object.keys(data);
        let datavalues = Object.values(data);
        let chartData = {
          labels: datalabels,
          datasets: [{
                label: this.$t("Number of Courses"),
                data: datavalues,
                backgroundColor: ["#c4e5ff","#E46651","#F7DC6F","#48C9B0","#138D75"],
                barThickness: 15,
          }]
        }
        return chartData;
      }
      else{
        let chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                  title:{
                      display: true,
                      text: this.$t("Learning Progress in Percentage"),
                  },
                },
                y: {
                    title:{
                        display: true,
                        text: this.$t("Number of Courses"),
                    },
                    ticks:{
                      stepSize: 1,
                    }
                   
                }
            },
            plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    }
            },
          
        };
        return chartOptions
      }
      
    },
    changedFilter(){
      if(!this.selectedUsers.length){
          this.filtereduserstats = this.userstats.users_data;
      }
      else{
        this.filtereduserstats = this.userstats.users_data.filter(v => this.selectedUsers.includes(v.user_id));  
      }
      
    },
    convertDate(dateString){
        const options = { year: "numeric", month: "long", day: "numeric" }
        return new Date(dateString).toLocaleDateString(this.currentUser.lang_code, options)
    },  
    async onScroll(){

        var userData = this.$refs["userData"];
        var marginTopUsers = userData.getBoundingClientRect().top;
        var innerHeight = window.innerHeight;

        if((marginTopUsers - innerHeight) < -50){
            var that = this;
            if(!this.querriedApi){
                this.isLoading = true;
                setTimeout(function(){
                    that.getUsersWriting();
                },1200);
            }

        }
    },

    async getUsersWriting(){

        if(!this.querriedApi){ //get only once
            if(this.userstats.next_page_url){
                let urlArray = this.userstats.next_page_url.split("?");
                let nextPage = urlArray[1];
                let pageNo = nextPage.split("=");

                this.isLoading = true;
                this.querriedApi = true;

                await store.dispatch(FETCH_USER_STATS, '?'+nextPage)
                .then((resp) => {
                    if(resp.success){
                        this.lastPulledPage = pageNo[1];
                        resp.data.users_data.forEach((item) => {
                            this.filtereduserstats.push(item);
                        });
                        this.querriedApi = false;
                        store.commit(SET_LOADING, false);
                        this.isLoading = false
                    }
                });

            }
            else{
            var userData = this.$refs["userData"];
                userData.innerHTML = this.$t("All Users loaded");
            }
        }
           
    }
    
  
  }
};
</script>

<style scoped>
.v-tabs-items {
    background-color: #fafafa;
}

</style>